import debounce from 'lodash-es/debounce';
import isFunction from 'lodash-es/isFunction';
import React from 'react';

type Props = {
  children: React.ReactNode | ((size: State) => React.ReactNode);
};

type State = {
  width: number;
  height: number;
};

const WindowSizeContext = React.createContext<State>({
  width: window.innerWidth,
  height: window.innerHeight,
});

export class WindowSizeProvider extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      width: window.innerWidth,
      height: window.innerHeight,
    };
    this.onResize = debounce(this.onResize.bind(this), 100);
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  render() {
    return (
      <WindowSizeContext.Provider value={this.state}>
        {isFunction(this.props.children) ? this.props.children(this.state) : this.props.children}
      </WindowSizeContext.Provider>
    );
  }

  private onResize() {
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight,
    });
  }
}

type WindowSizeConsumerProps = {
  children: (size: State) => React.ReactNode;
};

export const WindowSizeConsumer: React.SFC<WindowSizeConsumerProps> = ({ children }) => (
  <WindowSizeContext.Consumer>{children}</WindowSizeContext.Consumer>
);



// WEBPACK FOOTER //
// ./src/module/View/Common/component/WindowSizeProvider/WindowSizeProvider.tsx